module.exports = __webpack_public_path__ + "static/media/Error1.57b3efb4.png";